<template>
  <el-form
    label-position="top"
    :model="model"
  >
    <el-form-item label="Where did you hear about submitting to us?">
      <el-checkbox-group
        v-model="model.values"
        class="checkbox-item-group"
        @change="handleUpdate"
      >
        <el-checkbox
          v-for="option in options"
          :label="option"
          :key="option"
          class="checkbox-item"
        />
      </el-checkbox-group>
      <div class="survey-form__other-input">
        <el-checkbox
          :value="model.other.length > 0"
          @click.native="$refs.otherInputBox.focus()"
        />
        &nbsp;&nbsp;
        <el-input
          ref="otherInputBox"
          placeholder="Other"
          v-model="model.other"
          @change="handleUpdate"
        />
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import { getPayloadFromModel } from './surveyModelHelper';

export default {
  data() {
    return {
      options: [
        'Instagram',
        'Facebook',
        'Push notifications',
        'Weekly Newsletter',
        'Carousel Feature on Viddsee.com homepage',
        'From a friend’s recommendation',
      ],
      model: {
        values: [],
        other: '',
      },
    };
  },

  methods: {
    handleUpdate() {
      const payload = getPayloadFromModel(this.model, this.options);
      this.$emit('update', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-item-group {
  line-height: 2;
}
.checkbox-item {
  display: block;
}
.checkbox-item + .checkbox-item {
  margin-left: 0;
}

.survey-form__other-input {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/Shared/PostSubmissionDialog/SurveyForm.vue